import { useTranslation } from "react-i18next";
import PageHero from "@/components/layout/PageHero";
import { VisualSection, VisualCta } from "@/components/layout/visualLayout";
import VisualTileGrid from "@/components/layout/VisualTileGrid";
import SectionIntro from "@/components/layout/SectionIntro";
import Reveal from "@/components/common/Reveal";

const categories = ["c1", "c2", "c3", "c4", "c5"];

export default function Partners() {
  const { t } = useTranslation();

  return (
    <div data-testid="page-partners">
      <PageHero
        eyebrow={t("partners.eyebrow")}
        title={t("partners.title")}
        subtitle={t("partners.lead")}
        testId="partners-hero"
      />

      <VisualSection testId="partners-categories" divider>
        <SectionIntro eyebrow={t("partners.categoriesEyebrow")} />
        <VisualTileGrid
          items={categories.map((k, i) => ({
            title: t(`partners.${k}Title`),
            body: t(`partners.${k}Body`),
            testId: `partner-${i}`,
          }))}
          testId="partners-grid"
        />
      </VisualSection>

      <Reveal>
        <p className="text-center wit-body max-w-lg mx-auto mb-6">{t("partners.ctaHint")}</p>
      </Reveal>
      <VisualCta to="/contact?topic=partner" label={t("partners.cta")} testId="partners-cta" />
    </div>
  );
}
